import { render } from "./AboutModal.vue?vue&type=template&id=637db9d4&scoped=true"
import script from "./AboutModal.vue?vue&type=script&lang=js"
export * from "./AboutModal.vue?vue&type=script&lang=js"

import "./AboutModal.vue?vue&type=style&index=0&id=637db9d4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637db9d4"]])

export default __exports__